import React from 'react';
import { Link } from 'react-router-dom';
import './errorpage.css';

/**
 * 404 page.
 *
 * Prerendered to build/404.html, which serve-handler (and most static hosts)
 * return with a real HTTP 404 status — so an unknown URL is a genuine 404
 * rather than a soft 404 served as 200.
 *
 * Changes from the original: semantic <main>/<h1> instead of a stack of
 * <div>/<span>, Danish copy to match the rest of the site, and real <Link>s so
 * a crawler that lands here still has a route back into the site. The visual
 * structure and class names are unchanged.
 */
function ErrorPage() {

    return (
        <div>
            <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css" rel="stylesheet" />
            <main className="page-404">
                <div className="outer">
                    <div className="middle">
                        <div className="inner">
                            <div className="inner-circle"><i className="fa fa-cutlery" /><span>404</span></div>
                            <h1 className="inner-status">Siden blev ikke fundet</h1>
                            <span className="inner-detail">
                                Vi kunne ikke finde den side, du leder efter. Den kan være flyttet eller slettet.
                            </span>
                            <span className='inner-detail'>
                                <Link to="/" className="btn btn-info mtl home_button"><i className="fa fa-home" />&nbsp;
                                    Tilbage til forsiden
                                </Link>
                            </span>
                            <span className='inner-detail'>
                                <Link to="/menu">Se menuen</Link>
                                {' · '}
                                <Link to="/faq">Ofte stillede spørgsmål</Link>
                                {' · '}
                                <Link to="/contact">Kontakt os</Link>
                            </span>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
export default ErrorPage